<template>
    <div class="login-controller" />
</template>

<script>
import { RouterConfig, FingerprintJS } from '@/utils';

export default {
    name: 'AuthorizationController',
    data() {
        return {
            currentComponent: null,
        };
    },
    async mounted() {
        await this.checkDevice();
    },
    methods: {
        async checkDevice() {
            try {
                const { deviceId, LoggedIn, staffId } = localStorage;

                if (!deviceId) {
                    const fp = await FingerprintJS.load();
                    const { visitorId } = await fp.get();

                    localStorage.deviceId = visitorId;
                }

                const response = await this.$http.post('/v2/auth/device-id/check', {
                    deviceId: localStorage.deviceId,
                    userId: staffId,
                });

                localStorage.parametrs = JSON.stringify(response.data);

                // User is Authorized
                if (LoggedIn) {
                    this.$router.push({ name: 'main' });
                    return;
                }
                // TODO pinGlobalSetup / pinSetup влияют на вывод форм PinIn / PinUp
                const {
                    pinGlobalSetup,
                    pinSetup,
                } = response.data || {};

                if (pinGlobalSetup && pinSetup) {
                    this.$router.replace({ name: RouterConfig.loginPinIn.name });
                } else {
                    this.$router.replace({ name: RouterConfig.loginSignIn.name });
                }
            } catch (error) {
                console.error('[Controller]:', error);
                if (error?.response?.data) {
                    localStorage.parametrs = JSON.stringify(error.response.data);
                }

                this.$router.replace({ name: RouterConfig.loginSignIn.name });
            }
        },
    },
};
</script>

<style scoped>
.login-controller {
    height: 100%;
}

.loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}
</style>
